var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-multiple-checklist__item"},[_c('labeled-checkbox',{class:[
            'cf-c-labeled-checkbox--inside-collapsible',
            _vm.classLimitExceeded
        ],attrs:{"id":`checkbox-${_vm.id}`,"value":_vm.item.checked,"disabled":_vm.disabled || _vm.isAutoDisabled,"label":_vm.label},on:{"input":function($event){return _vm.$emit('input', $event)}}}),(_vm.disabled || _vm.isAutoDisabled)?_c('b-tooltip',{attrs:{"target":`checkbox-${_vm.id}`}},[_vm._v(" "+_vm._s(_vm.tooltipMessage)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }